import topicsSlice from "./slice";
import * as selectors from "./selectors";
import * as actions from "./actions";

export const TopicsActions = actions;
export const TopicsReducer = topicsSlice.reducer;
export const TopicsSelectors = selectors;
